import React, { useState, useEffect } from 'react';
import { Instagram } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import galleryStatic from '../data/galleryStatic';

const Gallery = () => {
  // Scroll reveal hooks
  const gridReveal = useScrollReveal({ threshold: 0.1 });
  const ctaReveal = useScrollReveal({ threshold: 0.3 });
  
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    setGalleryImages(galleryStatic);
  }, []);

  // Show only first 4 images for preview on landing page
  const displayImages = galleryImages.slice(0, 4);

  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Gallery Grid - show 4 preview images with stagger animation */}
        {displayImages.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <p className="text-xl font-bold">Gallery coming soon...</p>
            <p className="text-sm mt-2">New photo moments will be published here.</p>
          </div>
        ) : (
          <div 
            ref={gridReveal.ref}
            className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8"
          >
            {displayImages.map((image, index) => (
              <div 
                key={image.src || index} 
                className="relative group aspect-square overflow-hidden rounded-2xl bg-gray-100 shadow-sm hover:shadow-lg transition-all duration-500 opacity-100 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <img
                  src={image.src}
                  alt={image.alt || `Happy pet ${index + 1}`}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <div className="text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 flex items-center gap-2">
                    <Instagram size={18} className="text-white" />
                    <span className="text-sm font-medium">Instagram</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Instagram CTA with scroll reveal */}
        <div 
          ref={ctaReveal.ref}
          className={`mt-6 flex items-center justify-center transition-all duration-800 ${
            ctaReveal.isVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}
        >
          <a
            href="https://www.instagram.com/domigoindia?igsh=MWswcnE0bTk1dWw3&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Domigo Instagram in new tab"
            className="inline-flex items-center gap-3 bg-gradient-pink text-white font-semibold py-3 px-5 rounded-lg shadow-lg btn-smooth hover:shadow-pink"
          >
            <Instagram size={20} />
            <span>Follow @domigo on Instagram</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
